import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import { ImportantPerson } from '@lyceo/homi/pupils/util-models';
import { AuthActions } from '@lyceo/shared/auth/data-access';
import { PupilAPIActions } from '../pupil/pupil.actions';
import { mapPupilProfileToImportantPerson } from './important-person.functions';

export const IMPORTANT_PERSON_FEATURE_KEY: string = 'importantPerson';

// eslint-disable-next-line
export interface ImportantPersonState extends EntityState<ImportantPerson> {}

export const importantPersonAdapter: EntityAdapter<ImportantPerson> =
  createEntityAdapter<ImportantPerson>();

export const initialImportantPersonState: ImportantPersonState =
  importantPersonAdapter.getInitialState({});

const reducer: ActionReducer<ImportantPersonState, Action> = createReducer(
  initialImportantPersonState,
  on(
    AuthActions.logoutSuccess,
    (): ImportantPersonState => initialImportantPersonState,
  ),
  on(
    PupilAPIActions.getPupilProfileByIdSuccess,
    (state, action): ImportantPersonState =>
      importantPersonAdapter.upsertMany(
        mapPupilProfileToImportantPerson(action.pupilProfile),
        {
          ...state,
        },
      ),
  ),
);

export function importantPersonReducer(
  state: ImportantPersonState | undefined,
  action: Action,
): ImportantPersonState {
  return reducer(state, action);
}
